<template>
  <div>
    <Header />
    <div id="app" class="content-web container mt-5">
      <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
          <div class="col-12">
            <label class="title">Bộ lọc:</label>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
            <input
              v-model="searchForm.condition"
              type="text"
              id="typeSearch"
              class="form-control mr-2 mb-2"
              placeholder="Mã hoặc tên"
            />
            <button
              id="btnSearch"
              class="btn btn_control mr-2 mb-2"
              type="submit"
              v-on:click="searchData()"
            >
              Tìm kiếm
            </button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="table-box list-grid mb-5" v-if="loading">
        <div class="text-center">
          <div class="spinner-border text-dark" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div v-else class="table-box list-grid mb-5">
        <div class="row ml-0 mr-0">
          <div class="title col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <h6>SÁNG KIẾN CHUNG KHẢO</h6>
          </div>
          <div
            class="col-lg-8 col-md-8 col-sm-8 col-xs-12 d-flex justify-content-end pl-2"
          >
            <button
              type="button"
              class="btn"
              data-toggle="modal"
              data-target="#masterDataModal"
              v-on:click="openDialogCreate()"
              style="background-color:#1ab394;color:white;font-size: 14px"
            >
              Thêm
            </button>
          </div>
        </div>

        <div class="content-table">
          <table class="table table-hover table-md">
            <thead>
              <tr style=" text-align:top;">
                <th style="width: 180px;">Mã</th>
                <th style="width: 180px;">Tháng</th>
                <th style="width: 180px;">Ngày hiệu lực</th>
                <th style="width: 180px;">Trạng thái</th>
                <th style="width: 180px;">Kết thúc chấm điểm</th>
                <th style="width: 100px;">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-bind:class="[
                  'cell',
                  item['completeScore'] ? 'complete-score' : ''
                ]"
                v-for="item in listPeriod"
                v-bind:key="item.id"
              >
                <td>{{ item.code }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.processDate | date }}</td>
                <td>{{ item['lock'] ? 'Khóa chấm điểm' : 'Mở chấm điểm' }}</td>
                <td>
                  {{ item['completeScore'] ? 'Đã kết thúc' : 'Chưa kết thúc' }}
                </td>
                <td class="text-right">
                  <div class="dropdown">
                    <button
                      class="dropbtn dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Hành động
                      <span class="caret"></span>
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        v-if="!item.completeScore && !item['lock']"
                        class="dropdown-item"
                        v-on:click="openDialogUpdate(item)"
                        href="javascript:void(0)"
                        >Sửa</a
                      >
                      <a
                        v-if="!item.completeScore"
                        class="dropdown-item"
                        v-on:click="lockPeriod(item.id, item['lock'])"
                        href="javascript:void(0)"
                        >{{
                          item['lock'] ? 'Mở khóa chấm điểm' : 'Khóa chấm điểm'
                        }}</a
                      >
                      <a
                        v-if="!item.completeScore"
                        class="dropdown-item"
                        v-on:click="complete(item)"
                        href="javascript:void(0)"
                        >Kết thúc chấm điểm</a
                      >
                      <a
                        v-if="!item.completeScore"
                        class="dropdown-item"
                        v-on:click="moveIdToModalDelete(item)"
                        data-toggle="modal"
                        data-target="#modalDeleteFolder"
                        href="javascript:void(0)"
                        >Xoá</a
                      >
                      <a
                        v-if="
                          item.completeScore ||
                            username.toLowerCase() === 'thaottl@fpt.com' ||
                            username.toLowerCase() === 'annh8@fpt.com' ||
                            username.toLowerCase() === 'thinhnp13@fpt.com'
                        "
                        class="dropdown-item"
                        v-on:click="
                          item.completeScore
                            ? openScoringResultModal(item.code)
                            : openScoringResultModalNotCompleteScore(item.code)
                        "
                        href="javascript:void(0)"
                        >Xem kết quả</a
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- padding -->
        <div class="row mt-4 pagination">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
            <span v-if="pageSize * pageIndex > total && total != 0"
              >{{ pageSize * (pageIndex - 1) + 1 }}-{{ total }} của
              {{ total }}</span
            >
            <span v-if="pageSize * pageIndex <= total && total != 0"
              >{{ pageSize * (pageIndex - 1) + 1 }}-{{
                pageSize * pageIndex
              }}
              của {{ total }}</span
            >
            <span v-if="total == 0">0-0 của 0</span>
          </div>
          <div
            class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex"
          >
            <b-pagination
              v-if="total > pageSize"
              v-model="pageIndex"
              pills
              :total-rows="total"
              :per-page="pageSize"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- modal -->

    <b-modal ref="myModal" hide-footer :title="titleModal">
      <div class="d-block">
        <validation-observer ref="formModal">
          <form>
            <validation-provider
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <b-form-group class="form-group" label-for="input-name">
                <template slot="label">
                  Chọn tháng
                  <span class="text-danger font-italic note">*:</span>
                </template>
                <date-picker
                  class="date-control"
                  :input-class="{
                    'form-control datepicker is-valid': true,
                    ' form-control datepicker is-invalid':
                      validationContext.errors[0]
                  }"
                  placeholder="Tháng"
                  type="month"
                  :language="vi"
                  v-model="form.month"
                  :disabled="isUpdate"
                ></date-picker>
                <input
                  v-show="false"
                  :state="getValidationState(validationContext)"
                  v-model="form.month"
                />
                <div
                  v-show="validationContext.errors[0]"
                  id="input-name"
                  class="datepicker invalid-feedback"
                >
                  {{ validationContext.errors[0] }}
                </div>
              </b-form-group>
            </validation-provider>

            <validation-provider
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <b-form-group class="form-group" label-for="input-name">
                <template slot="label">
                  Ngày hiệu lực
                  <span class="text-danger font-italic note">*:</span>
                </template>
                <date-picker
                  class="date-control"
                  :input-class="{
                    'form-control datepicker is-valid': true,
                    ' form-control datepicker is-invalid':
                      validationContext.errors[0]
                  }"
                  placeholder="Ngày hiệu lực"
                  :language="vi"
                  type="date"
                  v-model="form.processDate"
                  :disabled-date="disabledEndTime"
                ></date-picker>
                <input
                  v-show="false"
                  :state="getValidationState(validationContext)"
                  v-model="form.processDate"
                />
                <div
                  v-show="validationContext.errors[0]"
                  id="input-name"
                  class="datepicker invalid-feedback"
                >
                  {{ validationContext.errors[0] }}
                </div>
              </b-form-group>
            </validation-provider>
          </form>
        </validation-observer>
      </div>

      <div style="float: right;">
        <b-button class="mt-3 btn-info" @click="saveData()">Lưu</b-button>
        <b-button class="mt-3" @click="hideDialogCreate">Đóng</b-button>
      </div>
    </b-modal>

    <b-modal
      ref="scoringResultModal"
      hide-footer
      title="Kết quả chấm điểm"
      size="xl"
    >
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Bảng</th>
            <th>Tiêu đề</th>
            <th>Tác giả</th>
            <th>Vàng</th>
            <th>Bạc</th>
            <th>Đồng</th>
            <th>Khuyến khích</th>
            <th>Chung cuộc</th>
            <th>Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in listScoringResult" :key="item.id">
            <td>{{ item.periodTable }}</td>
            <td>{{ item.ideaTitle }}</td>
            <td>{{ item.author }}</td>
            <td>{{ item.gold }}</td>
            <td>{{ item.silver }}</td>
            <td>{{ item.bronze }}</td>
            <td>{{ item.consolation }}</td>
            <td>
              <v-select
                :options="listMedal"
                :reduce="obj => obj.code"
                label="name"
                v-model="scoringUpdates[`score_${item.id}`].medal"
                @input="changeMedal(`score_${item.id}`, $event)"
                :clearable="false"
              ></v-select>
            </td>
            <td>{{ item.note }}</td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-12">
          <div class="btn-group pull-right">
            <button
              class="btn btn-primary"
              @click="publish()"
              v-if="!periodPublished"
            >
              Công bố kết quả
            </button>
            <button
              class="btn btn-primary"
              @click="updateScore()"
              v-if="!periodPublished"
            >
              Cập nhật kết quả
            </button>
            <button
              class="btn btn-danger"
              @click="reScore()"
              v-if="!periodPublished"
            >
              Hủy kết quả - chấm lại
            </button>
            <button class="btn btn-info" @click="closeScoringResultModal()">
              Đóng
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Result table when not completeScore -->
    <b-modal
      ref="scoringResultModalNotCompleteScore"
      hide-footer
      title="Kết quả chấm điểm"
      size="xl"
    >
      <table class="table">
        <thead>
          <tr>
            <th>Bảng</th>
            <th>Tiêu đề</th>
            <th>Tác giả</th>
            <th>Người chấm</th>
            <!-- <th>Danh hiệu</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in listIdea" :key="item.id">
            <td>
              {{
                listIdeaPeriod.filter(
                  ip => ip.ideaId.toString() === item.id.toString()
                )[0].periodTable
              }}
            </td>
            <td>{{ item.title }}</td>
            <td>{{ item.author }}</td>
            <td style="min-width: 300px;">
              <div
                v-for="maker in listIdeaScoring"
                v-if="maker.ideaId.toString() === item.id"
                :key="maker.id"
              >
                <span>{{ maker.createdBy }}</span>
                <span style="display: inline-block; float: right;">{{
                  maker.medal
                }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-12">
          <div class="btn-group pull-right">
            <button
              class="btn btn-info"
              @click="closeScoringResultModalNotCompleteScore()"
            >
              Đóng
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal Delete -->
    <div
      ref="modalDeleteFolder"
      class="modal fade"
      id="modalDeleteFolder"
      tabindex="-2"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteSubmisionLabel">
              Xóa folder tháng
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">Bạn có chắc muốn xóa folder này?</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="closeModalDeleteFolder()"
            >
              Hủy
            </button>

            <button
              @click="deleteFolder()"
              type="button"
              class="btn btn-info"
              data-dismiss="modal"
            >
              Đồng ý
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import moment from 'moment';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vi from 'vue2-datepicker/locale/vi';
import { BPagination } from 'bootstrap-vue';
import periodCommon from '../../common/period';
import scoringResultCommon from '../../common/scoringResult';
import masterDataCommon from '../../common/masterData';
import helper from '../../common/helper';
import Vue from 'vue';
import ideaScoring from '../../common/ideaScoring';
import ideaCommon from '../../common/idea';
import ideaPeriodCommon from '../../common/ideaPeriod';

const defaultSearchForm = {
  condition: ''
};

const defaultForm = {
  code: '',
  name: '',
  month: new Date(),
  processDate: new Date()
};

export default {
  name: 'FinalFolder',
  components: {
    Header,
    Footer,
    'b-pagination': BPagination,
    DatePicker
  },
  data() {
    return {
      vi: vi,
      listPeriod: [],
      searchForm: {
        condition: ''
      },
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      form: { ...defaultForm },
      loading: false,
      isUpdate: false,
      listScoringResult: [],
      scoringUpdates: {},
      listMedal: [],
      selectedPeriod: null,
      periodPublished: false,
      checkRole: false,
      scoringListByMarker: {},
      username: this.$cookies.get('username') || 'Anonymous',
      listIdeaScoring: [],
      listIdea: [],
      listIdeaPeriod: [],
      seletedFolder: {}
    };
  },
  filters: {
    date: function(date) {
      return moment(date).format('YYYY-MM-DD');
    }
  },
  computed: {
    titleModal() {
      if (this.form.id) {
        return 'Chỉnh sửa';
      }
      return 'Thêm';
    }
  },
  watch: {
    pageIndex: {
      immediate: false,
      handler(newVal, oldVal) {
        this.searchData();
      }
    }
  },
  async created() {
    await this.searchData(true);
    // await this.getRole();
    this.listMedal = [
      { code: 'gold', name: 'Vàng' },
      { code: 'silver', name: 'Bạc' },
      { code: 'bronze', name: 'Đồng' },
      { code: 'consolation', name: 'Khuyến khích' }
    ];
  },
  mounted() {},
  methods: {
    async searchData(resetPage) {
      if (resetPage) {
        this.pageIndex = 1;
      }
      const periodRes = await periodCommon.search(
        this.searchForm.condition,
        this.pageIndex,
        this.pageSize
      );
      this.listPeriod = periodRes.items;
      this.total = periodRes.totals;
    },
    clearSearch() {
      this.clearFilterSearch();
      this.searchSubmission(true);
    },
    clearFilterSearch() {
      this.searchForm = { ...defaultSearchForm };
    },
    openDialogCreate() {
      this.isUpdate = false;
      this.form = { ...defaultForm };
      this.$refs.myModal.show();
    },
    async openDialogUpdate(item) {
      let period = await periodCommon.get(item.id);
      this.form = { ...defaultForm };
      this.form.id = period.id;
      this.form.month = moment(period.name, 'MM/yyyy').toDate();
      this.form.name = period.name;
      this.form.processDate = new Date(period.processDate);
      this.isUpdate = true;
      this.$refs.myModal.show();
    },
    hideDialogCreate() {
      this.$refs.myModal.hide();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async saveData() {
      const validate = await this.$refs.formModal.validate();
      if (!validate) {
        return;
      }
      // save data
      if (this.form.month) {
        this.form.code = moment(this.form.month).format('yyyyMM');
        this.form.name = moment(this.form.month).format('MM/yyyy');
      }
      const formTemp = { ...this.form };

      let res = null;
      if (formTemp.id) {
        res = await periodCommon.update(formTemp);
      } else {
        res = await periodCommon.create(formTemp);
      }
      if (res && res.success) {
        this.hideDialogCreate();
      }
      await this.searchData(true);
    },
    disabledEndTime(date) {
      return date > new Date();
    },
    async lockPeriod(id, status) {
      let form = {
        id: id,
        lock: !status
      };
      await periodCommon.lock(form);
      await this.searchData();
    },
    async complete(item) {
      let form = {
        id: item.id
      };
      const res = await periodCommon.complete(form);
      await this.searchData();
      await this.openScoringResultModal(item.code);
      // console.log(res);
    },
    moveIdToModalDelete(item) {
      this.seletedFolder = item;
    },
    closeModalDeleteFolder() {
      this.$refs.modalDeleteFolder.hide();
    },
    async deleteFolder() {
      let form = {
        id: this.seletedFolder.id
      };
      const res = await periodCommon.deleteFoler(form);
      await this.searchData();
    },
    async getListMakersByIdea() {
      const scoringResults = [...this.listScoringResult];
      return Promise.all(
        scoringResults.map(async function(v) {
          let listMarkers = {};
          const markers = await ideaScoring.getByIdeaId(v.ideaId);
          listMarkers[`idea_scoring_${v.id}`] = {
            id: v.id,
            ideaId: v.ideaId,
            markers
          };
          return listMarkers;
        })
      );
    },
    async openScoringResultModal(code) {
      this.periodPublished = false;
      this.listScoringResult = [];
      this.scoringUpdates = {};
      const rawData = await scoringResultCommon.getByPeriod(code);
      /*this.listScoringResult = helper.sortArr(rawData,
        ["gold", "silver", "bronze", "consolation"], ["desc", "desc", "desc", "desc"]);*/
      this.listScoringResult = rawData;
      this.selectedPeriod = code;
      if (this.listScoringResult.length > 0) {
        let updates = {};
        this.listScoringResult.forEach(async v => {
          if (!this.periodPublished && v['publish']) {
            this.periodPublished = v['publish'];
          }
          updates[`score_${v.id}`] = {
            id: v.id,
            medal: v.finalMedal
          };
        });
        this.scoringUpdates = updates;
        // this.scoringListByMarker = await this.getListMakersByIdea();
        // console.log(`scoringListByMarker::`, this.scoringListByMarker[0]);
      }
      this.$refs.scoringResultModal.show();
    },
    closeScoringResultModal() {
      this.$refs.scoringResultModal.hide();
    },
    async openScoringResultModalNotCompleteScore(code) {
      this.periodPublished = false;
      this.listIdeaScoring = [];
      this.scoringUpdates = {};
      const rawData = await scoringResultCommon.getByPeriod(code);
      this.listScoringResult = rawData;
      this.listIdeaScoring = await ideaScoring.getByPeriod(code);
      this.selectedPeriod = code;
      const ideaIds = [...new Set(this.listIdeaScoring.map(v => v.ideaId))];
      this.listIdea = await Promise.all(
        ideaIds.map(async v => ideaCommon.getIdea(v))
      );
      this.listIdeaPeriod = await Promise.all(
        ideaIds.map(async v => ideaPeriodCommon.getByIdeaId(v))
      );
      // this.listIdeaPeriod =
      //   this.listIdeaPeriod && this.listIdeaPeriod.filter(i => !i.isDeleted);
      this.$refs.scoringResultModalNotCompleteScore.show();
    },
    closeScoringResultModalNotCompleteScore() {
      this.$refs.scoringResultModalNotCompleteScore.hide();
    },
    async updateScore() {
      const form = {
        updates: []
      };
      if (this.scoringUpdates) {
        const listKey = Object.keys(this.scoringUpdates);
        listKey.forEach(v => {
          form.updates.push(this.scoringUpdates[v]);
        });
      }
      await scoringResultCommon.update(form);
      await this.searchData(true);
      this.$refs.scoringResultModal.hide();
    },
    async reScore() {
      await periodCommon.reScore(this.selectedPeriod);
      await this.searchData();
      this.$refs.scoringResultModal.hide();
    },
    changeMedal(key, medal) {
      this.scoringUpdates[key].medal = medal;
      // console.log(this.scoringUpdates[key]);
    },
    async publish() {
      await scoringResultCommon.publish({ periodCode: this.selectedPeriod });
      await this.searchData();
      this.$refs.scoringResultModal.hide();
    }
    // async getRole() {
    //   if (
    //     Vue.$cookies.get('roles') !== null &&
    //     Vue.$cookies.get('roles') !== undefined
    //   ) {
    //     let role = Vue.$cookies.get('roles');
    //     this.checkRole =
    //       role.includes('system_admin') || role.includes('chief_jury');
    //   }
    // }
  }
};
</script>
<style scoped>
@import '../../assets/css/filter_customs.css';
@import '../../assets/css/table_customs.css';

div .errortemp {
  color: red;
  display: inline-block;
  margin-left: 5px;
}

.icon_status_active {
  text-align: center;
  color: #00cc00;
}

.mx-datepicker {
  width: 100% !important;
}

.datepicker.invalid-feedback {
  display: block !important;
}

.complete-score {
  background-color: #1ab394;
  color: #fff;
}

.complete-score:hover {
  color: #fff;
  background-color: rgb(20, 141, 108);
}
</style>

<style>
.datepicker.form-control.is-valid {
  background-image: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/FinalFolder.vue